import  {
  PRESUPUESTADOR_SAVE_COLORS,
} from './constants';

export const saveColors = (reservedColors) => {
  return (dispatch) => {
    dispatch({
      type: PRESUPUESTADOR_SAVE_COLORS,
      data: reservedColors
    })
  }
}

export function reducer(state, action) {
  if(action.type === PRESUPUESTADOR_SAVE_COLORS) {
    return {
      ...state,
      is_reservation: true,
      reservedColors: action.data,
    }
  }
  return state;
}
